import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "react-bootstrap";
import NotContent from "../../../../../components/ui/Form/NotContent";
import TableSmryPartners from "./TableSmryPartners";
const DataReportSmryByPartners = (props) => {
  const { isLoading, data } = props;

  if (isLoading) {
    return (
      <div className="w-full min-h-[60vh] flex justify-center items-center">
        {" "}
        <Spinner animation="border" />;
      </div>
    );
  }

  if (!data || !data.length) {
    return <NotContent />;
  }

  return <TableSmryPartners data={data} />;
};

DataReportSmryByPartners.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.array,
};

export default DataReportSmryByPartners;
